module.exports = __webpack_public_path__ + "static/media/Nicole Decker Headshot_1618522900150.ced80375.png";